import {
  getPriceSegmentsClientKey,
  useSelectedPriceSegments,
} from '@/stores/feed/priceSegmentsStore'
import { useUserInfoStore } from '@/stores/user/userInfoStore'

export const useFeedPriceSegmentsClientKey = () =>
  useUserInfoStore((state) =>
    getPriceSegmentsClientKey(state.currentClient?.id)
  )

export const useFeedPriceSegments = () =>
  useSelectedPriceSegments(useFeedPriceSegmentsClientKey())
